import { markAsMetState, markAsUnMetState } from '../../../routes/mark_as_met_unmet_routes';

const advisorMarkAsMetState = {
  ...markAsMetState,
  views: {
    'modal@ap-advisor': {
      template: `<mark-as-met-dialog></mark-as-met-dialog>`
    }
  }
};
const advisorMarkAsUnMetState = {
  ...markAsUnMetState,
  views: {
    'modal@ap-advisor': {
      template: `<mark-as-unmet-dialog generic-slot="$resolve.genericSlot"></mark-as-unmet-dialog>`
    }
  }
};
export const ApAdvisorMarkAsMetRoutes = {
  'ap-advisor.plan.edit.default.mark_as_met': { ...advisorMarkAsMetState },
  'ap-advisor.plan.edit.coursegroup.mark_as_met': { ...advisorMarkAsMetState },
  'ap-advisor.plan.edit.default.mark_as_unmet': { ...advisorMarkAsUnMetState },
  'ap-advisor.plan.edit.coursegroup.mark_as_unmet': { ...advisorMarkAsUnMetState }
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/routes/advisor_routes/planner/ap_advisor_mark_as_met_popup_routes.ts